module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVRIid1V0QrAIAjUsQ+vP+lPHY0YIU0NOsY66CGy8zqtSESSYJC40hIIZ0fLC1Pcgg+UalLKo+htNE8LVf65LZ4Nr+t72RLuBg//tWWvguoizs6H5Muf3mpLXk3akBn4V4QKWpplehRvY0S5FWDeYN0tsx6N4p+EuD4nogvkQnUTgYN/AQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/home/icn_pm.png
// module id = xI9V
// module chunks = 108